;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import {
  SEARCH_TYPE_GROUPS,
  // SEARCH_TYPE_ORGANIZATIONS,
  SEARCH_TYPE_PROVIDERS,
  type SearchType,
} from "../../../../lib/search/searchParams"

// Groups | Providers segmented control under the search bar.
// Plain Tailwind buttons (no MUI): this renders above the fold on the home
// page, which deliberately keeps MUI/Emotion out of its initial bundle.

export const SEARCH_TYPE_OPTIONS: ReadonlyArray<{
  type: SearchType
  label: string
}> = [
  { type: SEARCH_TYPE_GROUPS, label: "Groups" },
  { type: SEARCH_TYPE_PROVIDERS, label: "Providers" },
  // Temporarily hidden; preserve organization search and existing links.
  // { type: SEARCH_TYPE_ORGANIZATIONS, label: "Organizations" },
]

type SearchTypeToggleProps = {
  value: SearchType
  onChange: (type: SearchType) => void
  disabled?: boolean
}

export default function SearchTypeToggle({
  value,
  onChange,
  disabled = false,
}: SearchTypeToggleProps) {
  return (
    <div className="flex justify-center pt-[18px]" key="search-type-toggle">
      <div
        role="group"
        aria-label="What to search"
        className={`inline-flex rounded-full bg-white/15 p-[4px] font-roboto ${
          disabled ? "pointer-events-none opacity-70" : ""
        }`}
      >
        {SEARCH_TYPE_OPTIONS.map(({ type, label }) => {
          const active = type === value
          return (
            <button
              key={type}
              type="button"
              aria-pressed={active}
              data-search-type={type}
              onClick={() => {
                if (!active) onChange(type)
              }}
              className={`cursor-pointer rounded-full border-0 px-[18px] py-[8px] text-[16px] font-medium tracking-[0.32px] transition-colors min-[500px]:px-[24px] ${
                active
                  ? "bg-white text-[#092C3C] shadow-[0_2px_2px_rgba(0,0,0,0.15)]"
                  : "bg-transparent text-white hover:bg-white/10"
              }`}
            >
              {label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
